import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancellation-he',
  templateUrl: './cancellation-he.component.html',
  styleUrls: ['./cancellation-he.component.css']
})
export class CancellationHeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
